import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, List, Typography } from '@material-ui/core';
import { darken, makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { Network } from 'api';
import { useIntegrations, useNetworkCapabilities } from 'hooks';
import { Connection, CustomSVG } from 'components';
import { connectionPopup } from 'helpers';

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: 4,
    color: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.common.white,
    },
  },
  msteams: {
    backgroundColor: theme.custom.networks.msTeams,
    '&:hover': {
      backgroundColor: darken(theme.custom.networks.msTeams, 0.1),
    },
  },
  slack: {
    backgroundColor: theme.custom.networks.slack,
    '&:hover': {
      backgroundColor: darken(theme.custom.networks.slack, 0.1),
    },
  },
  list: {
    paddingBottom: theme.spacing(1),
  },
}));

const Integrations: FC = () => {
  const { t } = useTranslation();
  const { hasSlack, hasMSTeams } = useNetworkCapabilities();
  const classes = useStyles();
  const integrations = useIntegrations();

  const hasMSTeamsConnected = integrations.some(
    integration => integration.provider === Network.Msteams
  );
  const hasSlackConnected = integrations.some(
    integration => integration.provider === Network.Slack
  );

  function renderIntegrations() {
    return integrations.map(account => <Connection key={account.id} account={account} />);
  }

  return (
    <Grid container>
      <Grid item xs={3}>
        <Typography variant="h6">{t('common:integration_plural')}</Typography>
      </Grid>
      <Grid item xs={9}>
        <List className={classes.list}>{renderIntegrations()}</List>
        <Grid container spacing={2}>
          {!hasMSTeamsConnected && hasMSTeams && (
            <Grid item>
              <Button
                variant="contained"
                className={classNames(classes.button, classes.msteams)}
                onClick={() => connectionPopup(Network.Msteams)}
                startIcon={<CustomSVG name="msteamsWhite" />}
              >
                {t('user:connectTeamsAccount')}
              </Button>
            </Grid>
          )}
          {!hasSlackConnected && hasSlack && (
            <Grid item>
              <Button
                variant="contained"
                className={classNames(classes.button, classes.slack)}
                onClick={() => connectionPopup(Network.Slack)}
                startIcon={<CustomSVG name="slackMono" />}
              >
                {t('user:connectSlackAccount')}
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Integrations;
